import { render, staticRenderFns } from "./AboutUs_Background.vue?vue&type=template&id=3b15b7e6&"
import script from "./AboutUs_Background.vue?vue&type=script&lang=js&"
export * from "./AboutUs_Background.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports